module.exports = __webpack_public_path__ + "img/11_DSC7979-min.1b9ae010.jpg";